/**
 * UserDisplay Component
 *
 * Reusable component for displaying user avatar and name
 * Now receives user data directly (no more loading states!)
 */

import React from 'react';

import * as S from './styles';
import { UserData } from 'types/userData';

interface UserDisplayProps {
  userData: UserData | null | undefined;
  size?: 'small' | 'medium' | 'large';
  showEmail?: boolean;
  fallbackText?: string;
}

const UserDisplay: React.FC<UserDisplayProps> = ({
  userData,
  size = 'medium',
  showEmail = false,
  fallbackText = 'Usuário Desconhecido',
}) => {
  if (!userData) {
    return (
      <S.UserDisplayContainer>
        <S.Avatar size={size} src={undefined} />
        <S.UserInfo>
          <S.UserName size={size}>{fallbackText}</S.UserName>
          {showEmail && <S.UserEmail>-</S.UserEmail>}
        </S.UserInfo>
      </S.UserDisplayContainer>
    );
  }

  const fullName = `${userData.first_name} ${userData.last_name}`.trim();
  const initials =
    `${userData.first_name?.[0] || ''}${userData.last_name?.[0] || ''}`.toUpperCase();

  return (
    <S.UserDisplayContainer>
      <S.Avatar size={size} src={userData.image_url || undefined}>
        {!userData.image_url && initials}
      </S.Avatar>
      <S.UserInfo>
        <S.UserName size={size}>{fullName || 'Sem Nome'}</S.UserName>
        {showEmail && <S.UserEmail>{userData.email}</S.UserEmail>}
      </S.UserInfo>
    </S.UserDisplayContainer>
  );
};

export default UserDisplay;
